import { getStoredData } from './store';

export const services = [
  {
    id: 1,
    category: 'Ajustes',
    items: [
      { name: 'Entallar pantalón', price: 'desde 25 €', duration: '2-3 días' },
      { name: 'Acortar manga camisa', price: 'desde 15 €', duration: '1-2 días' },
      { name: 'Ajuste de vestido', price: 'desde 45 €', duration: '3-5 días' },
      { name: 'Entallar chaqueta', price: 'desde 55 €', duration: '3-5 días' },
      { name: 'Ajuste de falda', price: 'desde 30 €', duration: '2-3 días' },
    ],
    icon: 'ri-scissors-cut-line',
  },
  {
    id: 2,
    category: 'Reparaciones',
    items: [
      { name: 'Cambio de cremallera', price: 'desde 20 €', duration: '2-3 días' },
      { name: 'Remienda de roto', price: 'desde 15 €', duration: '1-2 días' },
      { name: 'Cambio de botones', price: 'desde 10 €', duration: '1 día' },
      { name: 'Reparación de bolsillo', price: 'desde 18 €', duration: '2 días' },
      { name: 'Desgarrón en tela delicada', price: 'desde 35 €', duration: '3-4 días' },
    ],
    icon: 'ri-tools-line',
  },
  {
    id: 3,
    category: 'Personalización',
    items: [
      { name: 'Aplicar parches decorativos', price: 'desde 20 €', duration: '2 días' },
      { name: 'Cambio de cuello', price: 'desde 35 €', duration: '3-4 días' },
      { name: 'Transformación de prenda', price: 'desde 60 €', duration: '5-7 días' },
      { name: 'Forro personalizado', price: 'desde 40 €', duration: '3-5 días' },
      { name: 'Detalle bordado básico', price: 'desde 50 €', duration: '5-7 días' },
    ],
    icon: 'ri-brush-line',
  },
];

export const howItWorks = [
  {
    step: 1,
    title: 'Sube tu prenda',
    description: 'Trae tu prenda al atelier o envíanos una foto por WhatsApp para valoración previa.',
    icon: 'ri-upload-cloud-line',
  },
  {
    step: 2,
    title: 'Valoración gratis',
    description: 'Te damos presupuesto sin compromiso en el acto o en menos de 24h. Sin sorpresas.',
    icon: 'ri-file-list-3-line',
  },
  {
    step: 3,
    title: 'Arreglo profesional',
    description: 'Nuestro equipo de sastres cualificados realiza el trabajo con precisión y cuidado.',
    icon: 'ri-scissors-line',
  },
  {
    step: 4,
    title: 'Recogida o entrega',
    description: 'Recoge tu prenda lista en el atelier o solicita envío a domicilio en Barcelona.',
    icon: 'ri-check-double-line',
  },
];

export const alterationTestimonials = [
  {
    id: 1,
    name: 'Carmen Ruiz',
    location: 'Barcelona — Eixample',
    text: 'Llevé mi abrigo de lana para entallarlo y en tres días lo tenía perfecto. El trato fue cercano y profesional. El precio muy razonable para la calidad del trabajo.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Pablo Medina',
    location: 'Barcelona — Gràcia',
    text: 'Cambié la cremallera de mi chaqueta de cuero y quedó como nueva. Me sorprendió la rapidez y el detalle en el acabado. Volveré sin duda.',
    rating: 5,
  },
  {
    id: 3,
    name: 'Ana López',
    location: 'Barcelona — Sant Gervasi',
    text: 'Transformaron un vestido antiguo de mi madre en algo moderno y elegante. El trabajo fue impecable y el resultado superó mis expectativas.',
    rating: 5,
  },
];

export const trustBadges = [
  { icon: 'ri-shield-check-line', label: 'Garantía de calidad', description: '100% satisfacción' },
  { icon: 'ri-time-line', label: 'Servicio rápido', description: '1 a 7 días' },
  { icon: 'ri-price-tag-3-line', label: 'Precios justos', description: 'Presupuesto previo' },
  { icon: 'ri-map-pin-line', label: 'En el centro', description: 'Rambla de Catalunya, 85, Principal - 2' },
];

export const getServices = () => getStoredData('admin_services', services);
export const getHowItWorks = () => getStoredData('admin_steps', howItWorks);
export const getAlterationTestimonials = () => getStoredData('admin_testimonials', alterationTestimonials);
export const getTrustBadges = () => getStoredData('admin_badges', trustBadges);